import { environment } from "@/environments/environment";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {PurchaseOrderModel, SearchPurchaseOrderResponse} from "@/app/shared/interface/purchase-order.interface";

@Injectable({
  providedIn: "root",
})

export class ProductLookupService {

  constructor(
    private http: HttpClient,
  ) { }

 searchPurchaseOrder(body: any) {
  return this.http.post<SearchPurchaseOrderResponse>(
    `${environment.baseURL}report/syncpurchaseorder/search-purchase-order`,
    body,
    {
      headers: {
        'Content-Type': 'application/json',
      }
    }
  );
}

  // Fetch số lô list
  searchProduct(body: any) {
    return this.http.post(`${environment.baseURL}`, body);
  }

  // Submit tra cứu
  lookup(body: any) {
    return this.http.post('https://tracuu.giathuoctot.com/api/tracuu', body);
  }
}
